<!-- Loader. -->
<section *ngIf="isLoading" style="text-align: center; margin: 40px 0">
	<freud-loader size="sm" [bgColor]="false"></freud-loader>
</section>

<!-- Header. -->
<div *ngIf="!isLoading" class="row user-card shadow clientsHeader">
	<!-- Always visible. -->
	<div class="row headerVisible">
		<div class="leftItems">
			<button (click)="goBack()" class="client-back">
				<img src="/assets/images/icons/back.png" />
			</button>
			<img
				class="user-avatar"
				src="{{ userData.photoUrl || '/assets/images/nophoto_blue_solid.png' }}"
				(click)="edit(userData.id)"
			/>
			<h1 class="force-inline" (click)="edit(userData.id)">
				{{ userData.displayName }}
			</h1>
		</div>

		<div class="rightItems">
			<div *ngIf="!isMobile" class="tableActionButton">
				<button class="btn btn-primary" (click)="edit(userData.id)">
					{{ 'PAGES.CLIENTS.EDITCLIENT' | translate }}
				</button>
			</div>
			<div *ngIf="userId" class="tableActionButton">
				<button
					class="btn btn-default detailButton"
					(click)="createAppointment($event, userId, true)"
				>
					{{ 'PAGES.CLIENTS.SCHEDULE' | translate }}
				</button>
			</div>
			<div *ngIf="userId" class="tableActionButton">
				<button
					*ngIf="
						!userData.refUserId &&
						userData.email &&
						!isSendingInvite &&
						!isInviteSent
					"
					class="btn btn-default detailButton btnInvite"
					(click)="inviteUser(userData.id)"
					pTooltip="{{ 'GENERAL.INVITEDESCRIPTION' | translate }}"
					tooltipPosition="bottom"
				>
					{{ 'GENERAL.SENDINVITE' | translate }}
				</button>
				<freud-loader
					*ngIf="isSendingInvite"
					size="sm"
					[bgColor]="false"
				></freud-loader>
			</div>

			<button
				*ngIf="userData && userData.refUserId"
				type="button"
				class="
					btn btn-default btn-outline btn-outline-big btn-outline-green
					chat-launcher
				"
				pTooltip="{{ 'PAGES.CLIENTS.CHAT' | translate }}"
				(click)="showChat(userData)"
			>
				<fa-icon icon="comments"></fa-icon>
			</button>

			<!-- we need a div to wrap the tooltip, see: https://stackoverflow.com/questions/47509819/angular-tooltip-does-not-show-for-disabled-buttons-in-chrome -->
			<div
				*ngIf="userData && !userData.refUserId"
				pTooltip="{{ 'PAGES.CLIENTS.NO_CHAT' | translate }}"
				class="btn-outline-big-fix-tooltip"
			>
				<button
					type="button"
					class="
						btn btn-default btn-outline btn-outline-big btn-outline-disabled
					"
					disabled
				>
					<fa-icon icon="comments"></fa-icon>
				</button>
			</div>

			<button
				*ngIf="userData && !userData.lastEventDate"
				type="button"
				class="btn btn-default btn-outline btn-outline-big btn-outline-warning"
				pTooltip="{{ 'PAGES.CLIENTS.DELETE' | translate }}"
				(click)="deleteContact($event, userData.id)"
			>
				<fa-icon icon="times-circle"></fa-icon>
			</button>

			<div
				*ngIf="userData && userData.lastEventDate"
				pTooltip="{{ 'PAGES.CLIENTS.NO_DELETE' | translate }}"
				class="btn-outline-big-fix-tooltip"
			>
				<button
					type="button"
					class="
						btn btn-default btn-outline btn-outline-big btn-outline-disabled
					"
					disabled
				>
					<fa-icon icon="times-circle"></fa-icon>
				</button>
			</div>
		</div>
	</div>
	<!-- /headerVisible. -->
</div>
<!-- /clientsHeader. -->

<!-- Client data. -->
<div
	*ngIf="!isLoading"
	class="row clientData"
	[ngClass]="{ formContent: !isMobile, shadow: !isMobile }"
>
	<section>
		<div class="row innerTitle">
			<h1 class="mainTitle">{{ 'PAGES.CLIENTS.CLIENTDATA' | translate }}</h1>

			<fa-icon
				[icon]="showDetails ? 'sort-up' : 'sort-down'"
				[ngClass]="{
					'sort-down': !showDetails,
					'sort-up': showDetails
				}"
				(click)="toggleShowDetails()"
			></fa-icon>
		</div>

		<!-- Side content. -->
		<div
			*ngIf="showDetails && userData"
			class="tabContentFrame tabSideContent"
			[ngClass]="{ formBlock: isMobile, shadow: isMobile }"
		>
			<div *ngIf="!isMobile" class="frameTitle">
				{{ 'PAGES.CLIENTS.CLIENTDATA' | translate | uppercase }}
			</div>

			<table class="table tabForm">
				<!-- First name. -->
				<tr>
					<!-- TODO: i18n -->
					<td class="tdTit">
						{{ 'GENERAL.DISPLAYNAME' | translate | uppercase }}:
					</td>
					<td class="tdVal">{{ userData.displayName }}</td>
				</tr>

				<!-- Status. -->
				<tr>
					<td class="tdTit">{{ 'GENERAL.STATUS' | translate | uppercase }}:</td>
					<td class="tdVal">{{ userData.statusText }}</td>
				</tr>

				<!-- Professional document. -->
				<tr>
					<td class="tdTit">{{ 'GENERAL.DOC' | translate | uppercase }}:</td>
					<td class="tdVal">{{ userData.fiscalId }}</td>
				</tr>

				<!-- ICD (International Classification of Diseases) -->
				<tr>
					<td class="tdTit">{{ 'GENERAL.ICD' | translate | uppercase }}:</td>
					<td class="tdVal">{{ userData.iCD }}</td>
				</tr>

				<!-- Session Price. -->
				<tr *ngIf="userData.sessionPrice">
					<td class="tdTit">
						{{ 'GENERAL.PRICEPERSESSION' | translate | uppercase }}:
					</td>
					<td class="tdVal">
						{{ userPref.CurrencySymbol }}
						{{ userData.sessionPrice | number: '.2-2' }}
					</td>
				</tr>
			</table>
		</div>

		<!-- /tabSideContent.. -->

		<!-- Main content. -->
		<div
			*ngIf="showDetails && userData"
			class="main-content tabContentFrame tabMainContent"
			[ngClass]="{ formBlock: isMobile, borderLeft: !isMobile }"
		>
			<div class="frameTitle">
				{{ 'GENERAL.CONTACT' | translate | uppercase }}:
			</div>

			<table class="table tabForm">
				<!-- E-Mail. -->
				<tr>
					<td class="tdTit">{{ 'GENERAL.EMAIL' | translate | uppercase }}:</td>
					<td class="tdVal">{{ userData.email }}</td>
				</tr>

				<!-- Phone (Fix). -->
				<tr>
					<td class="tdTit">{{ 'GENERAL.PHONE' | translate | uppercase }}:</td>
					<td class="tdVal">{{ userData.phoneFix }}</td>
				</tr>

				<!-- Phone (Mobile). -->
				<tr>
					<td class="tdTit">
						{{ 'GENERAL.PHONEMOBILE' | translate | uppercase }}:
					</td>
					<td class="tdVal">{{ userData.phoneMobile }}</td>
				</tr>

				<!-- Address. -->
				<tr>
					<td class="tdTit">
						{{ 'GENERAL.ADDRESS' | translate | uppercase }}:
					</td>
					<td class="tdVal">
						{{ userData.address }} <br />
						{{ userData.postalCode }} {{ userData.city }} {{ userData.country }}
					</td>
				</tr>

				<!-- Comments. -->
				<tr>
					<td class="tdTit">
						{{ 'GENERAL.COMMENTS' | translate | uppercase }}:
					</td>
					<td class="tdVal" [innerHTML]="userData.notes | nl2br"></td>
				</tr>
			</table>
		</div>
		<!-- /tabMainContent. -->
	</section>
</div>
<!-- /clientData. -->

<!-- Client events. -->
<div *ngIf="!isLoading" class="row">
	<client-event-list
		[showClientSearch]="false"
		[startWithDate]="false"
		[invertOrder]="true"
		[isContact]="isContact"
		[clientId]="clientId"
		(selectedEvent)="showEvent($event)"
	>
	</client-event-list>
</div>
<!-- /clientEvents. -->
